import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable,  of,  throwError } from 'rxjs';
import { IntraTvaCheckerResult } from '../Models/IntraTvaCheckerResult';
import { GetCompanyByVatParameters } from '../Models/GetCompanyByVatParameters';
import { CreditSafeResult } from '../Models/CreditSafeResult';
import { SharedDataService } from '../Services/shared-data/shared-data.service';
import { Address, CreditSafeCompany, InseeEtablissement, InseeUniteLegale, SimpleReponseResult, Supplier } from '../all-models';
import { catchError, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class InputCheckersService {
apiUrl: string;

  constructor(public sharedDataSvc: SharedDataService, private http: HttpClient) { 
    this.apiUrl = this.sharedDataSvc.apiBaseUrl + 'InputCheckers';
  }
  

  public getInseeEtablissements(siren:string, actifOnly:boolean = true) : Observable<InseeEtablissement[]> {
    let actifsUrl:string=actifOnly?'actifs':'tous';
    let url: string = `${this.apiUrl}/Insee/Siren/${siren}/Etablissements/${actifsUrl}`;
    this.sharedDataSvc.apiSirenLastError=undefined;
    return this.http.get<InseeEtablissement[]>(url)
    .pipe(map((result:any) => {
      this.sharedDataSvc.apiSirenLastError = result.Message;
      return result;
    })); 
  }

  public getInseeEtablissement(siret:string) : Observable<InseeEtablissement> {
    if ((siret||'').trim()==''){
      return throwError(() =>new Error( 'Le Siret ne doit pas être vide'));
    }
    if (!this.isSiret(siret)){
      return throwError(() =>new Error( 'Le n° Siret est invalide'));
    }
    let url: string = `${this.apiUrl}/Insee/Siret/${siret}/Etablissement`;
    this.sharedDataSvc.apiSirenLastError=undefined;
    return this.http.get<InseeEtablissement>(url)
    .pipe(map((result:any, index:number) => {
      this.sharedDataSvc.apiSirenLastError = result ? result.Message : `Pas d'étalissement ayant pour Siret ${siret}`;
      return result;
    }))
    .pipe(
      catchError((err) => {
        if (err.status != 404) {
          console.log('Erreur levée par l\'API Insee getInseeEtablissement');
          console.error(err);
        }
        return throwError(()=>err);  
      })
    ); 
  }
  
  public SiretSiegeValidate(siret: string): Observable<SimpleReponseResult> {
    let url: string = `${this.apiUrl}/Insee/Siret/${siret}/${this.sharedDataSvc.lngCod}/SiegeValidate`;
    this.sharedDataSvc.apiSirenLastError=undefined;
    return this.http.get<SimpleReponseResult>(url)
    .pipe(map((result:any) => {
      this.sharedDataSvc.apiSirenLastError = result.Message;
      return result;
    }));
  }


  public IntraTvaCheck(numIntraTva: string): Observable<IntraTvaCheckerResult> {
    let url: string = `${this.apiUrl}/IntraTvaCheck/${numIntraTva}`;
    return this.http.get<IntraTvaCheckerResult>(url);
  }

  public getCompanyByVat(numIntraTva: string): Observable<CreditSafeResult> {
    let url: string = `${this.apiUrl}/getCompanyByVat`;
    let param: GetCompanyByVatParameters = new GetCompanyByVatParameters();
    param.CountryCodes = ['FR'];
    param.VatNumber = numIntraTva;
    return this.http.post<CreditSafeResult>(url, param);
  }

  
  //Unicité du n° IntraTva activée uniquement pour les pays étrangers
  public UniciteIntraTvaActive(supplierAddress:Address):boolean{
    if (!supplierAddress|| !supplierAddress.Country){
      return false;
    } else {
      return ['fr','gf,re'].indexOf(supplierAddress.Country.CountryCod2.toLowerCase())<0;
    }
  }

  
  private findIntraTva_Old(supplier:Supplier,address:Address): void {
    if (!supplier) return;
    this.IntraTvaCheck(supplier.TvaIntra)
      .subscribe(res => {
        if (res && res.isValid) {
          //Si n° intracom valide, on met à jour le champ du modèle avec les données retournées
          supplier.TvaIntra = res.CountryCode+res.VatNumber;
          if (res.CountryCode.toLowerCase()=='fr'){
            // La mise à jour de la raison sociale et de l'adresse ne se font que pour la France, les pays étrangers  ne sont pas tous renseignés 
            supplier.SupplierName = (res.traderName || '');
            if ((res.traderAddress||'').length==0) return;
            let addr1:string= (res.traderAddress || '').split('\n')[0];
            if (address){
              if (!Number.isNaN(addr1.split(' ')[0])){
                address.AddrNum=addr1.split(' ')[0];
                address.Addr1=addr1.substring(address.AddrNum.length+1);
              } else {
                address.Addr1 = addr1;
              }  
              if ((res.traderAddress || '').split('\n').length==0) return;
              let addr2: string=res.traderAddress.substr(addr1.length + 1);
              if (addr2){
                if (!Number.isNaN(addr2.split(' ')[0]) && (addr2.split(' ')[0]).length>=5){
                  address.PostalCod=addr2.split(' ')[0];
                  address.City=addr2.substring(address.PostalCod.length+1);
                } else {
                  address.Addr2 = res.traderAddress.substr(address.Addr1.length + 1);
                }            
              }
            }            
          }          
        }
      })
  }

  public findIntraTva(supplier: Supplier, address: Address): void {
    if (!supplier) return;
    this.getSupplierIntraVAT(supplier.Id, supplier.TvaIntra)
      .subscribe({
        next: res => {
          if (res && res.isValid) {
            //Si n° intracom valide, on met à jour le champ du modèle avec les données retournées
            supplier.TvaIntra = res.CountryCode + res.VatNumber;
            if (res.CountryCode.toLowerCase() == 'fr') {
              // La mise à jour de la raison sociale et de l'adresse ne se font que pour la France, les pays étrangers  ne sont pas tous renseignés 
              supplier.SupplierName = (res.traderName || '');
              if ((res.traderAddress || '').length == 0) return;
              let addr1: string = (res.traderAddress || '').split('\n')[0];
              if (address) {
                if (!Number.isNaN(addr1.split(' ')[0])) {
                  address.AddrNum = addr1.split(' ')[0];
                  address.Addr1 = addr1.substring(address.AddrNum.length + 1);
                } else {
                  address.Addr1 = addr1;
                }
                if ((res.traderAddress || '').split('\n').length == 0) return;
                let addr2: string = res.traderAddress.substr(addr1.length + 1);
                if (addr2) {
                  if (!Number.isNaN(addr2.split(' ')[0]) && (addr2.split(' ')[0]).length >= 5) {
                    address.PostalCod = addr2.split(' ')[0];
                    address.City = addr2.substring(address.PostalCod.length + 1);
                  } else {
                    address.Addr2 = res.traderAddress.substr(address.Addr1.length + 1);
                  }
                }
              }
            }
          }
        },
        error: (reason) => this.sharedDataSvc.alertSubscriptionReject(reason)
      });
  }

  getSupplierCreditSafeCompany(supplierId:number):Observable<CreditSafeCompany>{
    let url: string = `${this.apiUrl}/Suppliers/${supplierId}/CreditSafeCompany`;
    return this.http.get<CreditSafeCompany>(url);
  }

  
  public getSupplierIntraVAT(supplierId:number, tvaIntra: string = null):Observable<IntraTvaCheckerResult>{
    let url: string = `${this.apiUrl}/Suppliers/${supplierId}/IntraTvaCheck`; 
    if (tvaIntra && tvaIntra.trim().length>0){
      url += `/${tvaIntra}`;
    }
    return this.http.get<IntraTvaCheckerResult>(url);
  }
  
  getSupplierInseeUniteLegale(supplierId:number,siren: string = null):Observable<InseeUniteLegale | null>{    
    let url: string = `${this.apiUrl}/Suppliers/${supplierId}/InseeUniteLegale`;
    if (siren && siren.trim().length>0){
      url += `/${siren}`;
      if (this.isSiret(siren)) siren=siren.substring(0,9);
      if (!this.isSiren(siren)) return of(null);
    }
    return this.http.get<InseeUniteLegale | null>(url);
  }
  
  getSupplierInseeEtablissement(supplierId:number,siret: string = null):Observable<InseeEtablissement | null>{    
    let url: string = `${this.apiUrl}/Suppliers/${supplierId}/InseeEtablissement`;
    if (siret && siret.trim().length>0){
      url += `/${siret}`;
      if (!this.isSiret(siret)) return of(null);
    }
    return this.http.get<InseeEtablissement | null>(url);
  }
  getSupplierInseeEtablissements(supplierId:number,siren: string = null):Observable<InseeEtablissement[]>{    
    let url: string = `${this.apiUrl}/Suppliers/${supplierId}/InseeEtablissements`;
    if (siren && siren.trim().length>0){
      url += `/${siren}`;
      if (this.isSiret(siren)) siren=siren.substring(0,9);
      if (!this.isSiren(siren)) return of([]);
    }
    return this.http.get<InseeEtablissement[]>(url);
  }

  isSiret(input: string): boolean{
    const siretRegex = /^\d{14}$/;
    return siretRegex.test(input);
  }
  isSiren(input: string): boolean{
    const sirenRegex = /^\d{9}$/;
    return sirenRegex.test(input);
  }
}
